export const epochToDateString = (
  epoch,
  monthFormat: 'long' | 'short' | undefined = 'short'
) => {
  const options = {
    // weekday: 'long',
    month: monthFormat,
    day: 'numeric',
  };
  const date = new Date(Number(epoch) * 1000);

  return date.toLocaleDateString('en-IN', options);
};

export const epochToDateStringWithYear = (
  epoch,
  monthFormat: 'long' | 'short' | undefined = 'short'
) => {
  const options = {
    year: 'numeric',
    month: monthFormat,
    day: 'numeric',
  };
  const date = new Date(Number(epoch) * 1000);

  return date.toLocaleDateString('en-IN', options);
};

export const epochToDateTimeString = (epoch) => {
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  const date = new Date(Number(epoch) * 1000);

  return date.toLocaleDateString('en-IN', options);
};

// Legacy author photos for columns published before author images were
// stored on the story docs, keyed by the author's first name. Absolute
// paths so the lookup works from any route depth.
const legacyColumnAuthorImages: Record<string, string> = {
  wolfgang: '/assets/contributor.png',
  susanne: '/assets/admin2.jpg',
  jack: '/assets/admin3.png',
};

// Public byline: a guest override (authorName) wins over the creator's name.
export const getAuthorName = (story: {
  authorName?: string;
  name?: string;
}): string => story?.authorName || story?.name || '';

// Author photo: stored image (guest upload or staff profile stamped at
// creation) → legacy hardcoded map → undefined (caller picks its own
// final fallback: letter avatar on detail pages, banner image in lists).
export const getAuthorImage = (story: {
  authorName?: string;
  authorImageUrl?: string;
  name?: string;
}): string | undefined =>
  story?.authorImageUrl ||
  legacyColumnAuthorImages[
    getAuthorName(story)?.split(' ')?.[0]?.toLowerCase()
  ];

export const getRandomColor = (letter: string) => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const index = letters.indexOf(letter);
  const hue = (index * 360) / letters.length;
  return `hsl(${hue}, 70%, 80%)`;
};
